<template>
  <main class="flex-1 overflow-y-auto focus:outline-none">
    <div class="py-6">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 class="text-2xl font-semibold text-gray-900">
          {{ isEdit ? 'Upraviť ready made firmu' : 'Pridať ready made firmu' }}
        </h1>
      </div>
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div class="py-4">
          <form @submit.prevent="save" class="space-y-8 divide-y divide-gray-200">
            <div class="space-y-6">
              <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

                <div class="sm:col-span-4">
                  <label for="company_name" class="block text-sm font-medium text-gray-700">Názov firmy</label>
                  <div class="mt-1">
                    <input
                      type="text"
                      id="company_name"
                      v-model="form.company_name"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="Zadajte názov firmy"
                    />
                  </div>
                  <p v-if="errors.company_name" class="mt-2 text-sm text-red-600">{{ errors.company_name }}</p>
                </div>

                <div class="sm:col-span-2">
                  <label for="ico" class="block text-sm font-medium text-gray-700">IČO</label>
                  <div class="mt-1">
                    <input
                      type="text"
                      id="ico"
                      v-model="form.ico"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="12345678"
                    />
                  </div>
                  <p v-if="errors.ico" class="mt-2 text-sm text-red-600">{{ errors.ico }}</p>
                </div>

                <div class="sm:col-span-6">
                  <label for="headquarters" class="block text-sm font-medium text-gray-700">Sídlo</label>
                  <div class="mt-1">
                    <input
                      type="text"
                      id="headquarters"
                      v-model="form.headquarters"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="Ulica 1, 831 01 Bratislava"
                    />
                  </div>
                  <p v-if="errors.headquarters" class="mt-2 text-sm text-red-600">{{ errors.headquarters }}</p>
                </div>

                <div class="sm:col-span-2">
                  <label for="founding_date" class="block text-sm font-medium text-gray-700">Dátum vzniku</label>
                  <div class="mt-1">
                    <input
                      type="date"
                      id="founding_date"
                      v-model="form.founding_date"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                  <p v-if="errors.founding_date" class="mt-2 text-sm text-red-600">{{ errors.founding_date }}</p>
                </div>

                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700">Platca DPH</label>
                  <div class="mt-3 flex items-center space-x-4">
                    <label class="inline-flex items-center">
                      <input type="radio" :value="true" v-model="form.vat_payer" class="focus:ring-teal-500 h-4 w-4 text-teal-600 border-gray-300" />
                      <span class="ml-2 text-sm text-gray-700">Áno</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="radio" :value="false" v-model="form.vat_payer" class="focus:ring-teal-500 h-4 w-4 text-teal-600 border-gray-300" />
                      <span class="ml-2 text-sm text-gray-700">Nie</span>
                    </label>
                  </div>
                </div>

                <div class="sm:col-span-2">
                  <label for="price" class="block text-sm font-medium text-gray-700">Cena (€)</label>
                  <div class="mt-1">
                    <input
                      type="number"
                      id="price"
                      v-model.number="form.price"
                      min="0"
                      step="0.01"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="0.00"
                    />
                  </div>
                  <p v-if="errors.price" class="mt-2 text-sm text-red-600">{{ errors.price }}</p>
                </div>

                <div class="sm:col-span-2">
                  <label for="sale_price" class="block text-sm font-medium text-gray-700">Zľavnená cena (€) <span class="text-gray-400">(nepovinné)</span></label>
                  <div class="mt-1">
                    <input
                      type="number"
                      id="sale_price"
                      v-model.number="form.sale_price"
                      min="0"
                      step="0.01"
                      class="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="0.00"
                    />
                  </div>
                </div>

              </div>
            </div>

            <div class="pt-5">
              <div class="flex justify-end">
                <button
                  type="button"
                  @click="router.push({ name: 'Ready made firmy' })"
                  class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                >
                  Zrušiť
                </button>
                <button
                  type="submit"
                  class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                  :disabled="loading"
                >
                  <span v-if="loading">Ukladá sa...</span>
                  <span v-else>Uložiť</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import ReadyMadeCompanyDataService from '@/services/ReadyMadeCompanyDataService'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

const router = useRouter()
const route = useRoute()
const loading = ref(false)

const companyId = computed(() => route.params.id as string | undefined)
const isEdit = computed(() => !!companyId.value)

const form = reactive({
  company_name: '',
  ico: '',
  headquarters: '',
  vat_payer: false,
  founding_date: '',
  price: 0,
  sale_price: null as number | null,
})

const errors = reactive({
  company_name: '',
  ico: '',
  headquarters: '',
  founding_date: '',
  price: '',
})

onMounted(async () => {
  if (isEdit.value) {
    await fetchCompany()
  }
})

async function fetchCompany() {
  loading.value = true
  try {
    const response = await ReadyMadeCompanyDataService.getById(Number(companyId.value))
    if (response.data?.success) {
      const data = response.data.data
      form.company_name = data.company_name
      form.ico = data.ico
      form.headquarters = data.headquarters
      form.vat_payer = data.vat_payer
      form.founding_date = data.founding_date ? data.founding_date.substring(0, 10) : ''
      form.price = data.price
      form.sale_price = data.sale_price ?? null
    }
  } catch (error) {
    toast.error('Chyba pri načítavaní firmy')
    router.push({ name: 'Ready made firmy' })
  } finally {
    loading.value = false
  }
}

function validate(): boolean {
  errors.company_name = ''
  errors.ico = ''
  errors.headquarters = ''
  errors.founding_date = ''
  errors.price = ''

  let valid = true

  if (!form.company_name.trim()) {
    errors.company_name = 'Názov firmy je povinný'
    valid = false
  }
  if (!form.ico.trim()) {
    errors.ico = 'IČO je povinné'
    valid = false
  }
  if (!form.headquarters.trim()) {
    errors.headquarters = 'Sídlo je povinné'
    valid = false
  }
  if (!form.founding_date) {
    errors.founding_date = 'Dátum vzniku je povinný'
    valid = false
  }
  if (form.price == null || form.price < 0) {
    errors.price = 'Cena je povinná a musí byť kladná'
    valid = false
  }

  return valid
}

async function save() {
  if (!validate()) return

  loading.value = true
  try {
    const payload = {
      company_name: form.company_name,
      ico: form.ico,
      headquarters: form.headquarters,
      vat_payer: form.vat_payer,
      founding_date: form.founding_date,
      price: form.price,
      sale_price: form.sale_price || null,
    }

    if (isEdit.value) {
      await ReadyMadeCompanyDataService.update(Number(companyId.value), payload)
      toast.success('Firma bola úspešne upravená')
    } else {
      await ReadyMadeCompanyDataService.create(payload)
      toast.success('Firma bola úspešne pridaná')
    }

    router.push({ name: 'Ready made firmy' })
  } catch (error: any) {
    const msg = error?.response?.data?.message || 'Nastala chyba pri ukladaní'
    toast.error(msg)
  } finally {
    loading.value = false
  }
}
</script>
